"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StepsInfo = _interopRequireDefault(require("./StepsInfo"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chip = _interopRequireDefault(require("../Chip/chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WizardHeader = function WizardHeader(_ref) {
  var disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["disabled"]);

  var classes = (0, _classnames.default)({
    disabled: disabled
  });
  return _react.default.createElement("header", {
    className: classes
  }, _react.default.createElement("div", {
    className: "co-header__content"
  }, renderFigure(props), renderRightSection(props)));
};

var renderRightSection = function renderRightSection(props) {
  return renderChip(props) || renderSteps(props);
};

var renderChip = function renderChip(_ref2) {
  var info = _ref2.info,
      warning = _ref2.warning,
      danger = _ref2.danger,
      success = _ref2.success,
      message = _ref2.message;
  return message ? _react.default.createElement(_chip.default, {
    alternate: true,
    success: success,
    info: info,
    warning: warning,
    danger: danger
  }, message) : null;
};

var renderSteps = function renderSteps(_ref3) {
  var totalSteps = _ref3.totalSteps,
      currentStep = _ref3.currentStep;
  return totalSteps && currentStep ? _react.default.createElement(_StepsInfo.default, {
    totalSteps: totalSteps,
    currentStep: currentStep
  }) : null;
};

var figureStyle = 'co-figure__text--right';

var renderFigure = function renderFigure(_ref4) {
  var placeholder = _ref4.placeholder,
      loading = _ref4.loading,
      imageAlt = _ref4.imageAlt,
      imageUrl = _ref4.imageUrl,
      title = _ref4.title;

  if (placeholder) {
    return _react.default.createElement(PlaceholderFigure, null);
  }

  if (loading) {
    return _react.default.createElement(LoadingFigure, null);
  }

  return _react.default.createElement(Figure, {
    imageAlt: imageAlt,
    imageUrl: imageUrl,
    title: title
  });
};

var Figure = function Figure(_ref5) {
  var imageAlt = _ref5.imageAlt,
      imageUrl = _ref5.imageUrl,
      title = _ref5.title;
  return _react.default.createElement("div", {
    className: figureStyle
  }, _react.default.createElement("img", {
    className: "co-brand__image",
    src: imageUrl,
    alt: imageAlt
  }), _react.default.createElement("span", {
    className: "co-brand__name"
  }, title));
};

var LoadingFigure = function LoadingFigure() {
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(figureStyle, 'co-wizard__placeholder co-wizard__placeholder--animated')
  }, _react.default.createElement("div", {
    className: "co-brand__image"
  }), _react.default.createElement("span", {
    className: "co-brand__name"
  }));
};

var PlaceholderFigure = function PlaceholderFigure() {
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(figureStyle, 'co-wizard__placeholder')
  }, _react.default.createElement("div", {
    className: "co-brand__image"
  }), _react.default.createElement("span", {
    className: "co-brand__name"
  }));
};

WizardHeader.propTypes = {
  loading: _propTypes.default.bool,
  placeholder: _propTypes.default.bool,
  imageUrl: _propTypes.default.string,
  imageAlt: _propTypes.default.string,
  title: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  totalSteps: _propTypes.default.number,
  currentStep: _propTypes.default.number,
  warning: _propTypes.default.bool,
  info: _propTypes.default.bool,
  danger: _propTypes.default.bool,
  success: _propTypes.default.bool,
  message: _propTypes.default.string
};
var _default = WizardHeader;
exports.default = _default;
WizardHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WizardHeader",
  "props": {
    "loading": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "imageUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "imageAlt": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "totalSteps": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "currentStep": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "warning": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "info": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "danger": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "success": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};